import { isLocal } from "config/env";

export function getGatewayApiUrl() {
  if (isLocal()) {
    return "https://apigateway.palmswap.org/dev";
  }

  return process.env.REACT_APP_API_GATEWAY_URL;
}
